<template>
  <v-dialog
    :width="540"
    :persistent="true"
    v-model="useDialog"
  >
    <div class="layerPopup">
      <div class="layerTit">
        Excelファイルのダウンロード
        <span class="smTxt">Excelファイルをダウンロードするための理由を記載します。</span>
      </div>
      <div class="layerContent">
        <div class="excelPwDialog">
          <v-form ref="pwForm" v-model="isValid" @submit.prevent>
            <dl>
              <dt>理由記載</dt>
              <dd>
                <v-text-field
                  v-model="excel.excelComment"
                  :rules="[rules.required, rules.commentMaxLen]"
                  type="text"
                  autocomplete="new-password"
                  hint="理由記載文字数15文字以内可能"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="eventExcel()"
                  class="UXinput UXicon-edit"
                  outline
                  solo
                ></v-text-field>
              </dd>
            </dl>
            <dl v-if="isUsePw">
              <dt>パスワード設定</dt>
              <dd>
                <v-text-field
                  :append-icon="showPw ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.passwordValidate, rules.min]"
                  :type="showPw ? 'text' : 'password'"
                  autocomplete="new-password"
                  @click:append="showPw = !showPw"
                  v-model="excel.password"
                  hint="半角英数字と特殊文字を組み合わせた8文字以上15文字以下"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="eventExcel()"
                  class="UXinput iconBtn noErrorType"
                  outline
                  solo
                ></v-text-field></dd>
            </dl>
            <dl v-if="isUsePw">
              <dt>パスワード設定（確認用）</dt>
              <dd>
                <v-text-field
                  :append-icon="showPwCf ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.passwordValidate, rules.min, rules.checkedPassword]"
                  :type="showPwCf ? 'text' : 'password'"
                  autocomplete="new-password"
                  @click:append="showPwCf = !showPwCf"
                  v-model="excel.passwordConfirm"
                  hint="半角英数字と特殊文字を組み合わせた8文字以上15文字以下"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="eventExcel()"
                  class="UXinput iconBtn noErrorType"
                  outline
                  solo
                ></v-text-field>
              </dd>
            </dl>
          </v-form>
          <div class="cenBtn">
            <v-btn outline round large class="UXbtn" @click="closePopup">キャンセル</v-btn>
            <v-btn round dark large color="#ff8c8c" class="UXbtn" @click="eventExcel" :disabled="!isValid">保存とダウンロード</v-btn>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="closePopup">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import helper from '@/util/helpers'
import {mapGetters} from 'vuex'

export default {
  name: 'excel_password_dialog',
  props: {
    excelDownload: Function
  },
  data () {
    return {
      isValid: false,
      useDialog: false,
      showPw: '',
      showPwCf: '',
      excel: {
        excelComment: '',
        password: '',
        passwordConfirm: ''
      },
      rules: {
        min: v => v.length >= 6 || '6文字以上で入力してください。',
        passwordValidate: v => /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/g.test(v) || '半角英数字と特殊文字を組み合わせた8文字以上15文字以下',
        max: v => v.length <= 13 || '最大13桁まで入力できます',
        required: value => !!value || '入力情報がありません。',
        commentMaxLen: v => v.replace(/ /gi, '').length <= 15 || '最大15文字まで入力可能.',
        checkedPassword: v => {
          if (v && v !== this.excel.password) {
            return 'パスワードが一致しません。'
          } else {
            return false
          }
        }
      },
      isUsePw: false
    }
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'currentBrandId'
    ])
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.$eventBus.$on('excelPasswordDialog', (val) => {
        this.axios.get('/api/brand/customOption/excelSecure/fetch', {
          params: {
            brandId: this.currentBrandId || val.currentBrandId
          }
        }).then(result => {
          if (result.data.code !== 0) throw result.data.message
          const option = JSON.parse(result.data.data)
          if (option.USE_SECURE) {
            this.isUsePw = true
          }
          this.useDialog = true
        })
      })
    },
    eventExcel () {
      if (!this.isValid) return
      const isPwCheckPass = this.isUsePw && helper.checkPassword(this.excel.password, this.excel.passwordConfirm)
      if (isPwCheckPass || !this.isUsePw) {
        this.$emit('input', this.excel)
        this.excelDownload()
        this.closePopup()
      }
    },
    closePopup () {
      this.$refs.pwForm.resetValidation()
      this.excel = {
        excelComment: '',
        password: '',
        passwordConfirm: ''
      }
      this.useDialog = false
    }
  }
}
</script>

<style lang="scss">
  .excelPwDialog {
    padding-top:10px;
    dl {
      padding-bottom: 5px;
      dt {
        padding-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
        color: #121212;
      }
      dd {
        padding-bottom:5px;
        .UXinput .v-input__control .v-input__append-inner {
          opacity: 1;
        }
        .UXinput {
          padding-bottom:12px;
        }
      }
    }
    .cenBtn {
      padding:5px 0 3px 0;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/excel_password_dialog.vue